import { ErrorHandler, Injectable } from '@angular/core';
import { Logger } from 'src/app/shared/shared-base/amg-ui/logging/logging/logger';

@Injectable()
export class LoggingErrorHandler extends ErrorHandler {
  constructor(private _logger: Logger) {
    super();
  }
  public handleError(error: any): void {
    super.handleError(error);
    this._logger.error(error);
  }
}
